"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
var format = function (appName, version, environment, systemInfo) {
    if (systemInfo === void 0) { systemInfo = ""; }
    return "".concat(appName, "/").concat(version, " (Kiwi.com ").concat(environment, ") ").concat(systemInfo);
};
exports.format = format;
//# sourceMappingURL=format.js.map